module.exports = __webpack_public_path__ + "img/4.6ae09a38.jpg";